import React, { useState, useEffect } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import "../../../../assets/css/cms/poll.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Row, Col, Form, Button } from "react-bootstrap";
import { ALLOW_ACCESS } from "../../../../constants/cms";
import { useSelector, useDispatch } from "react-redux";
import { formatDateFor } from "../../../../utils/index";
import DesktopDatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import Box from "@mui/material/Box";
import { format } from "date-fns";
import {
  getPollFilterEntityTypeAction,
  getPollFilterEntityNameAction,
  getPollSubPageAction,
} from "../../../../../store/actions/cms/pollAction";
import { clearMessage, clearDropDowndata } from "../../../../../store/slices/pollSlice";

export const ManagePollForm = (props) => {
  const { mappings, setMappings, handleSubmit, errors, setErrors,setWarning,showWarning } = props;
  const dispatch = useDispatch();
  const characterCount = props.question.replace(/\s/g, "").length;
  const [showAlert, setShowAlert] = useState(false);
  const [debounceState, setDebounceState] = useState(false);
  const {
    pollDeviceFilterData,
    pollPageTypeFilterData,
    pollEntityTypeFilterData,
    pollDomainTypeData,
    pollEntityNameFilterData,
    pollSubPageData,
  } = useSelector((state) => state?.pollCreationReducer);
  // regex for url validation, the usr should be internal only

  const handleQuestionChange = (e) => {
    const input = e.target.value;
    const countWithoutSpaces = input?.replace(/\s/g, "").length;
    if (countWithoutSpaces <= 150) {
      props.setQuestion(input);
      clearError("question");
    }
  };

  const handleOptionChange = (index, value) => {
    const updated = [...props.options];
    updated[index] = value;
    props.setOptions(updated);

    if (value.length > 100) {
      props.setOptionLengthErrors((prev) => ({
        ...prev,
        [index]: "Maximum limit is 100 characters",
      }));
    } else {
      props.setOptionLengthErrors((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[index];
        return updatedErrors;
      });
    }

    // Ensure options are strings before applying .trim()
    if (
      updated.filter((opt) => typeof opt === "string" && opt.trim() !== "")
        .length >= 2
    ) {
      clearError("options");
    }
  };

  const addOption = () => {
    if (props.options.length < 5) {
      props.setOptions([...props.options, ""]);
    }
  };

  const removeOption = (index) => {
    if (props.options.length > 2) {
      const updated = props.options.filter((_, i) => i !== index);
      props.setOptions(updated);
    }
  };

  const handleOnChange = (field, obj, index) => {
    const updated = [...mappings];
    updated[index][field] = obj;

    if (field === "page_type") {
      updated[index].entity_type = null;
      updated[index].entity_name = [];

      let params = {};
      params.entity_type = obj?.entity_type ? obj?.entity_type : obj?.id;

      if (obj?.value !== "Articles" && obj?.value !== "News") {
        if (obj?.value === "College Detail Pages")
          params.entity_type = "college";
        dispatch(
          getPollFilterEntityNameAction({
            filter_type: "entity_name",
            page_type: obj?.id,
            ...params,
          })
        );
      } else {
        dispatch(
          getPollFilterEntityTypeAction({
            filter_type: "entity_type",
            page_type: obj?.id,
          })
        );
      }
    }

    if (field === "entity_type") {
      updated[index].entity_name = [];
      updated[index].sub_page = null;
      dispatch(
        getPollFilterEntityNameAction({
          filter_type: "entity_name",
          entity_type: obj?.id,
          page_type: mappings[index]?.page_type?.id,
        })
      );
    }

    if (field === "entity_name") {
      if (Array.isArray(obj)) {
        updated[index].entity_name = obj;

        updated[index].sub_page = null;

        dispatch(
          getPollFilterEntityNameAction({
            filter_type: "entity_name",
            page_type: updated[index]?.page_type?.id,
            entity_type: updated[index]?.entity_type?.id,
          })
        );

        const selectedEntity = obj[0];

        if (
          updated[index].page_type?.id?.toLowerCase?.() ===
          "college_detail_pages" &&
          selectedEntity?.entity_id
        ) {
          dispatch(
            getPollSubPageAction({
              filter_type: "sub_page",
              page_type: "college_detail_pages",
              entity_type: "college",
              entity_id: selectedEntity.entity_id,
            })
          );
        }

      }
    }
    setMappings(updated);
  };

  const handleMappingChange = (index, field, value) => {
    const updated = [...mappings];
    updated[index][field] = value;

    const pageType = updated[index].page_type;
    const entityType = updated[index].entity_type;

    if (field === "page_type") {
      updated[index].entity_type = "";
      updated[index].entity_name = [];

      if (value?.show_entity_name) {
        dispatch(
          getPollFilterEntityTypeAction({
            filter_type: "entity_type",
            page_type: value?.id,
          })
        );
      }
    }

    if (field === "entity_type" || field === "page_type") {
      const isCollegePage =
        pageType?.id?.toLowerCase?.() === "college_detail_pages";

      let finalEntityType = "";

      if (pageType?.entity_type) {
        finalEntityType = pageType.entity_type;
      } else if (entityType?.id) {
        finalEntityType = entityType.id;
      } else {
        finalEntityType = isCollegePage ? "college" : pageType?.id;
      }

      if (pageType?.show_entity_name) {
        dispatch(
          getPollFilterEntityNameAction({
            filter_type: "entity_name",
            page_type: pageType?.id,
            entity_type: finalEntityType,
          })
        );
      }

      // Sub Page logic for college
      if (
        isCollegePage &&
        (entityType?.value?.toLowerCase() === "college" ||
          finalEntityType === "college")
      ) {
        dispatch(
          getPollSubPageAction({
            filter_type: "sub_page",
            page_type: "college_detail_pages",
            entity_type: "college",
            entity_id: 123,
          })
        );
      }
    }

    setMappings(updated);
  };

  const addMappingBlock = () => {
    dispatch(clearMessage());
    dispatch(clearDropDowndata());


    if (mappings.length) {
      setMappings([
        ...mappings,
        { page_type: "", entity_type: "", entity_name: [] },
      ]);
    }
  };

  const removeMappingBlock = (index) => {
    if (mappings.length > 1) {
      setMappings(mappings.filter((_, i) => i !== index));
    }
  };

  const duplicateIndices = props.options?.map((opt, idx, arr) => {
    // If the option is an object, use its 'value' property; otherwise, use the option itself
    const currentValue = typeof opt === "object" ? opt.value : opt;

    // Find the index of the first occurrence of the current value in the array
    return arr.findIndex((item) => {
      // Extract the value of the item being compared
      const itemValue = typeof item === "object" ? item.value : item;

      // Check if the current item's value matches the current option's value
      return itemValue === currentValue;
    }) !== idx && currentValue !== "" // Ensure the current index is not the first occurrence and the value is not empty
      ? idx // If it's a duplicate, return the current index
      : null; // Otherwise, return null
  });

  const clearError = (fieldKey) => {
    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[fieldKey];
      return updated;
    });
  };

  const showShowOnCheckbox = (map) => {
    const allowedPageTypes = ["exams", "news", "degree_pages", "branch_pages"];
    return allowedPageTypes.includes(map.page_type?.id?.toLowerCase());
  };

  useEffect(() => {
    if (props.getPollsData || props.getPollsError) {
      setShowAlert(true);

      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // 3 seconds

      return () => clearTimeout(timer);
    }
  }, [props.getPollsData, props.getPollsError]);

  const handleSearchTerm = (term, index, field) => {
    let entityType = mappings[index]?.page_type?.id === 'college_detail_pages'
      ? 'college' : mappings[index]?.entity_type
        ? mappings[index]?.entity_type?.id : mappings[index]?.page_type?.entity_type ? mappings[index]?.page_type?.entity_type : mappings[index]?.page_type?.id;
    let params = {
      'filter_type': 'entity_name',
      'page_type': mappings[index]?.page_type?.id,
      'entity_type': entityType,
      'term': term
    }
    if (field === 'entity_name') {
      let inDebounce = debounceState;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => {
        dispatch(getPollFilterEntityNameAction(params));
      }, 1000);
      setDebounceState(inDebounce);
    }
    else return
  }
  useEffect(() => {
    props.getPollsData?.mappings?.map((mapItem) => {
      if (mapItem?.page_type != null || mapItem?.page_type != undefined) {
        let pageType = mapItem?.page_type
        dispatch(
          getPollFilterEntityTypeAction({
            filter_type: "entity_type",
            page_type: pageType,
          })
        );
      }
    })
  }, [])
  // check duplicate values
  const getEntityValidationError = (array) => {
    const seen = new Set();
    for (const obj of array) {
      if (obj.entity_name && Array.isArray(obj.entity_name)) {
        if(obj.show_on_college){
          setWarning("")
          return null 
      }
        for (const entity of obj.entity_name) {
          if (entity.value) {
            if (seen.has(entity.value)) {
              setWarning("This combination of Entity Type and Entity Name is already used in another mapping")
              return true;
            }
            seen.add(entity.value);
          }
        }
      }
    }
    setWarning("")
    return null; // No duplicates found
  }

  useEffect(() => {
    if (pollEntityTypeFilterData) {
      const updatedMappings = mappings.map((item) => {
        const entityData = pollEntityTypeFilterData?.entity_types?.find(
          (obj) => obj.id === item?.entity_type?.id
        );
        return {
          ...item,
          entity_type: entityData || item.entity_type, // Update entity_type if entityData is found
        };
      });
      // getEntityValidationError(updatedMappings)
      setMappings(updatedMappings); // Update the mappings state
    }
  }, [pollEntityTypeFilterData]);

  // useEffect(()=>{
  //   getEntityValidationError(mappings)
  // },[mappings])


  const checkDuplicateMappings = () => {
    const seen = new Set();
  
    for (let i = 0; i < mappings.length; i++) {
      const map = mappings[i];
      const key = JSON.stringify({
        page_type: map.page_type?.id || "",
        entity_type: map.entity_type?.id || "",
        entity_name: (map.entity_name || []).map(e => e.id).sort(),
        domain: map.domain?.id || "",
        sub_page: (Array.isArray(map.sub_page) ? map.sub_page.map(s => s.id).sort() : []),
        field3: map.field3?.trim() || "",
        show_on_article: !!map.show_on_article, 
        show_on_college: !!map.show_on_college,
      });
  
      if (seen.has(key)) {
        setWarning("Duplicate mapping entries are not allowed.");
        return true;
      }
  
      seen.add(key);
    }
  
    setWarning(""); 
    return false;
  };

  useEffect(() => {
    checkDuplicateMappings();
  }, [mappings]);
  
  return (
    <div className="p-3">
      <h4 className="mb-4">Polls Add/Edit</h4>

      <div className="examfilter">
        {/* Poll Question */}
        <Form.Group className="mb-4">
          <Form.Label>Poll Question</Form.Label>
          <Form.Control
            type="text"
            placeholder="Add Question"
            value={props.question}
            onChange={handleQuestionChange}
            isInvalid={!!errors.question}
          />
          <Form.Control.Feedback type="invalid">
            {errors.question}
          </Form.Control.Feedback>

          <div className="text-end small text-muted mt-1">
            [{characterCount}/150]
          </div>
        </Form.Group>

        {/* Poll Options */}
        {props.options.map((option, index) => (
          <div key={index} className="mb-2">
            <div className="d-flex align-items-center">
              <Form.Control
                type="text"
                className={`me-2 ${duplicateIndices.includes(index) || errors.options
                    ? "is-invalid"
                    : ""
                  }`}
                placeholder={`Option ${index + 1}`}
                value={
                  typeof option === "string" ? option : option?.value || ""
                }
                onChange={(e) => handleOptionChange(index, e.target.value)}
                onBlur={(e) => handleOptionChange(index, e.target.value.trim())}
                maxLength={101}
              />
              {props.options.length > 2 && (
                <Button
                  variant="danger"
                  size="sm"
                  className="me-2"
                  onClick={() => removeOption(index)}
                >
                  <FaMinus />
                </Button>
              )}
              {index === props.options.length - 1 &&
                props.options.length < 5 && (
                  <Button variant="success" size="sm" onClick={addOption}>
                    <FaPlus />
                  </Button>
                )}
            </div>

            {duplicateIndices.includes(index) && (
              <div className="text-danger small mt-1">
                Duplicate option not allowed
              </div>
            )}

            {/* Max Length Error */}
            {props.optionLengthErrors[index] && (
              <div className="text-danger small mt-1">
                {props.optionLengthErrors[index]}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Poll Entity Mapping */}
      <h5 className="mt-5 mb-3">Poll Entity Mapping</h5>
      {mappings.map((map, index) => (
        <div key={index} className="examfilter mb-3">
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Page Type</Form.Label>
                <Select
                  placeholder="Select Page Type"
                  isSearchable
                  isClearable
                  options={pollPageTypeFilterData?.page_type}
                  getOptionLabel={(opt) => opt?.value}
                  getOptionValue={(opt) => opt?.id}
                  value={map.page_type}
                  onChange={(obj) => {
                    handleOnChange("page_type", obj, index);
                    clearError(`page_type_${index}`);
                  }}
                  classNamePrefix="react-select"
                  className={errors[`page_type_${index}`] ? "is-invalid" : ""}
                />
                {errors[`page_type_${index}`] && (
                  <div className="text-danger small mt-1">
                    {errors[`page_type_${index}`]}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Entity Type</Form.Label>
                <Select
                  isSearchable
                  isClearable
                  value={map.entity_type || null}
                  onChange={(obj) => handleOnChange("entity_type", obj, index)}
                  options={pollEntityTypeFilterData?.entity_types}
                  getOptionLabel={(opt) => opt?.value}
                  getOptionValue={(opt) => opt?.id}
                  isDisabled={
                    map.page_type?.value !== "Articles" &&
                    map.page_type?.value !== "News"
                  }
                  onFocus={() => {
                    dispatch(getPollFilterEntityTypeAction({ filter_type: "entity_type", page_type: map?.page_type?.id, }))
                  }}
                />
                
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Entity Name</Form.Label>
                <Select
                  isMulti
                  isSearchable
                  isClearable
                  value={map.entity_name}
                  getOptionLabel={(option) => option["value"]}
                  getOptionValue={(option) => option["id"]}
                  onChange={(selectedOptions) => {
                    handleOnChange("entity_name", selectedOptions, index);
                    // checkDuplicateEntityName(index, map.entity_type, map.entity_name)
                    getEntityValidationError(mappings)

                  }}
                  onInputChange={(term) => handleSearchTerm(term, index, "entity_name")}
                  options={pollEntityNameFilterData?.entity_names || []}
                  isDisabled={
                    (map?.entity_type?.has_data != undefined && map?.entity_type?.has_data == false) ||
                    (!map?.page_type?.show_entity_name) ||
                    ((map?.page_type?.value === 'Articles' || map?.page_type?.value === 'News') && !map?.entity_type?.value)
                  }
                  onFocus={() => {
                    let EntityType = map?.entity_type?.id ? map?.entity_type?.id : map.page_type?.entity_type
                    dispatch(getPollFilterEntityNameAction({ filter_type: "entity_name", page_type: map?.page_type?.id, entity_type: EntityType }))
                  }}
                />
              </Form.Group>
            </Col>

            {map.page_type?.id?.toLowerCase() === "college_detail_pages" && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>College Sub Page</Form.Label>
                  <Select
                    placeholder="Select College Sub Page"
                    isClearable
                    isMulti
                    isSearchable
                    value={map.sub_page}
                    onChange={(obj) => {
                      handleMappingChange(index, "sub_page", obj);
                      clearError(`sub_page_${index}`);
                    }}
                    options={pollSubPageData?.sub_pages || []}
                    getOptionLabel={(opt) => opt?.value}
                    getOptionValue={(opt) => opt?.id}
                    isDisabled={!map.entity_name || map.entity_name.length === 0}
                  />
                </Form.Group>
              </Col>
            )}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Domain</Form.Label>
                <Select
                  placeholder="Select Domain"
                  isClearable
                  isSearchable
                  options={pollDomainTypeData || []}
                  getOptionLabel={(opt) => opt?.value}
                  getOptionValue={(opt) => opt?.id}
                  value={map.domain}
                  onChange={(obj) => {
                    handleMappingChange(index, "domain", obj);
                    clearError(`domain_${index}`);
                  }}
                  classNamePrefix="react-select"
                  className={errors[`domain_${index}`] ? "is-invalid" : ""}
                />
                {errors[`domain_${index}`] && (
                  <div className="text-danger small mt-1">
                    {errors[`domain_${index}`]}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>URL</Form.Label>
                <Form.Control
                  type="text"
                  value={map.field3 ?? ""}
                  onChange={(e) => {
                    handleMappingChange(index, "field3", e.target.value);
                    clearError(`url_${index}`);
                  }}
                  isInvalid={
                    !!errors[`url_${index}`]
                  }
                  placeholder="Add URL (e.g., https://www.careers360.in)"
                />
                <Form.Control.Feedback type="invalid">
                  invalid URL
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {showShowOnCheckbox(map) && (
              <div className="show_on">
                <Form.Check
                  className="status_check"
                  type="checkbox"
                  label={`Show on Articles`}
                  id={`Show on Articles${index}`}
                  checked={map.show_on_article}
                  onChange={(e) => {
                    handleMappingChange(
                      index,
                      "show_on_article",
                      e.target.checked
                    )
                    if (e.target.checked) {
                      setWarning("")
                    } else {
                      getEntityValidationError(mappings)
                    }
                  }
                  }
                />

                <Form.Check
                  className="status_check"
                  type="checkbox"
                  label={`Show on Colleges`}
                  id={`Show on Colleges${index}`}
                  checked={map.show_on_college}
                  onChange={(e) =>{
                    handleMappingChange(
                      index,
                      "show_on_college",
                      e.target.checked
                    )
                    if (e.target.checked) {
                      setWarning("")
                    } else {
                      if(mappings?.[index]?.show_on_article){
                        setWarning("")
                      }else{
                        getEntityValidationError(mappings)
                      }
                    }
                  }
                  }
                />
              </div>
            )}
            {/* Warning for duplicate entity_type and entity_name */}
            {showWarning && (
                  <div className="text-danger small mt-1">
                    {showWarning}
                  </div>
                )}
            <Col className="text-end">
              {mappings.length === 1 ? (
                <Button
                  variant="primary"
                  size="sm"
                  onClick={addMappingBlock}
                  className="mb-2 px-4 py-2"
                >
                  Add Mapping
                </Button>
              ) : (
                <>
                  {mappings.length > 1 && (
                    <Button
                      variant="danger"
                      size="sm"
                      className="me-2"
                      onClick={() => removeMappingBlock(index)}
                    >
                      <FaMinus />
                    </Button>
                  )}
                  {index === mappings.length - 1 && (
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={addMappingBlock}
                    >
                      <FaPlus />
                    </Button>
                  )}
                </>
              )}
            </Col>
          </Row>
        </div>
      ))}

      {/* Poll Attributes */}
      <h5 className="mt-5 mb-3">Poll Attributes</h5>
      <div className="examfilter">
        <Row>
          <Col md={4} className="mb-3">
            <Form.Group className="mb-3 date_input" controlId="startDate">
              <Form.Label>Start Date</Form.Label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="Custom input"
                  value={props.startDate}
                  // maxDate={props.endDate && new Date(props.endDate)}
                  minDate={new Date()}
                  onChange={(sValue) => {
                    if (sValue) {
                      props.setStartDate(sValue.toISOString());
                      clearError("startDate");
                    } else props.setStartDate(null);
                  }}
                  renderInput={({ inputRef, inputProps, InputProps }) => (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Form.Control
                        ref={inputRef}
                        {...inputProps}
                        className={"input_pd"}
                        placeholder="dd-mm-yyyy"
                        value={
                          props.startDate
                            ? format(new Date(props.startDate), "dd-MM-yyyy")
                            : ""
                        }
                      />
                      {InputProps?.endAdornment}
                      {props.startDate && (
                        <Button
                          variant="link"
                          onClick={() => props.setStartDate(null)}
                          className={"cross-button position-absolute"}
                        >
                          &#x2716;
                        </Button>
                      )}
                    </Box>
                  )}
                />
              </LocalizationProvider>
            </Form.Group>
            {errors.startDate && (
              <div className="text-danger small mt-1">{errors.startDate}</div>
            )}
          </Col>

          <Col md={4} className="mb-3">
            <Form.Group className="mb-3 date_input" controlId="endDate">
              <Form.Label>End Date</Form.Label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="Custom input"
                  value={props.endDate}
                  minDate={new Date(props.startDate)}
                  onChange={(sValue) => {
                    if (sValue) {
                      props.setEndDate(sValue.toISOString());
                      clearError("endDate");
                    } else props.setEndDate(null);
                  }}
                  renderInput={({ inputRef, inputProps, InputProps }) => (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Form.Control
                        ref={inputRef}
                        {...inputProps}
                        className={"input_pd"}
                        placeholder="dd-mm-yyyy"
                        value={
                          props.endDate
                            ? format(new Date(props.endDate), "dd-MM-yyyy")
                            : ""
                        }
                      />
                      {InputProps?.endAdornment}
                      {props.endDate && (
                        <Button
                          variant="link"
                          onClick={() => props.setEndDate(null)}
                          className={"cross-button position-absolute"}
                        >
                          &#x2716;
                        </Button>
                      )}
                    </Box>
                  )}
                />
              </LocalizationProvider>
            </Form.Group>
            {errors.endDate && (
              <div className="text-danger small mt-1">{errors.endDate}</div>
            )}
          </Col>

          <Col md={4} className="mb-3">
            <Form.Group>
              <Form.Label>Device Type</Form.Label>
              <Select
                isMulti
                placeholder="Select Device Type"
                isClearable
                isSearchable
                options={pollDeviceFilterData?.device_type}
                getOptionLabel={(opt) => opt?.value}
                getOptionValue={(opt) => opt?.id}
                value={props.deviceType}
                onChange={(selected) => {
                  props.setDeviceType(selected);
                  if (selected?.length) {
                    clearError("deviceType");
                  }
                }}
                className={errors.deviceType ? "is-invalid" : ""}
                classNamePrefix="react-select"
              />
              {errors.deviceType && (
                <div className="text-danger small mt-1">
                  {errors.deviceType}
                </div>
              )}
            </Form.Group>
          </Col>
          {/* {deviceType?.value?.toLowerCase() === "app" && (
            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>App Screen Selection</Form.Label>
                <Select
                  placeholder="Select Screen"
                  isClearable
                  isSearchable
                  options={[
                    { label: "A", value: "a" },
                    { label: "B", value: "b" },
                    { label: "C", value: "c" },
                  ]}
                />
              </Form.Group>
            </Col>
          )} */}

          <Col md={4} className="mb-3">
            <Form.Group className="mb-3">
              <Form.Label>Show</Form.Label>
              <Select
                isMulti
                placeholder="Select Visibility"
                options={ALLOW_ACCESS.map((opt) => ({
                  label: opt.value,
                  value: opt.id,
                }))}
                value={ALLOW_ACCESS.filter((opt) =>
                  props.show.includes(opt.id?.toString?.())
                ).map((opt) => ({
                  label: opt.value,
                  value: opt.id,
                }))}
                onChange={(selected) => {
                  props.setShow(selected.map((opt) => opt.value.toString()));
                  if (selected.length) clearError("show");
                }}
                classNamePrefix="react-select"
                className={errors.show ? "is-invalid" : ""}
              />
              {errors.show && (
                <div className="text-danger small mt-1">{errors.show}</div>
              )}
            </Form.Group>
          </Col>

          <Col md={4} className="mb-3">
            <Form.Group className="mb-3">
              <Form.Label>Allow Access</Form.Label>
              <Select
                isMulti
                placeholder="Select Access"
                options={ALLOW_ACCESS.map((opt) => ({
                  label: opt.value,
                  value: opt.id,
                }))}
                value={ALLOW_ACCESS.filter((opt) =>
                  props.allowAccess.includes(opt.id?.toString?.())
                ).map((opt) => ({
                  label: opt.value,
                  value: opt.id,
                }))}
                onChange={(selected) => {
                  props.setAllowAccess(
                    selected.map((opt) => opt.value.toString())
                  );
                  if (selected.length) clearError("allowAccess");
                }}
                classNamePrefix="react-select"
                className={errors.allowAccess ? "is-invalid" : ""}
              />
              {errors.allowAccess && (
                <div className="text-danger small mt-1">
                  {errors.allowAccess}
                </div>
              )}
            </Form.Group>
          </Col>

          <Col md={4} className="mb-3">
            <Form.Label>Visibility After End Date (in days)</Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="Enter days to show after end date"
              value={props.visibleDate}
              onChange={(e) => {
                const sanitizedValue = e.target.value.replace(/\D/g, "");
                props.setVisibleDate(sanitizedValue);
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="mt-4 d-flex">
        <Form.Check
          className="status_check"
          type="checkbox"
          label="Publish/Unpublish"
          id="Publish/Unpublish"
          checked={props.isPublished}
          onChange={(e) => props.setIsPublished(e.target.checked)}
        />
        <div className="manage_ranking_button_cover mx-5">
          <button
            className={`exam_button ${showWarning ? "disabled_button" : ""} `}
            type="submit"
            onClick={props.handleSubmit}
            disabled={showWarning?.length > 0}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
